/*global Modernizr, console */
/*jslint browser:true */

(function() {
    'use strict';

    let ticking = false;

    // 100vw doesn't take into account for the scrollbar. So we do that by setting a CSS variable.
    function _calculateVariables() {
        document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");
        document.documentElement.style.setProperty('--scrollbar-height', (window.innerHeight - document.documentElement.clientHeight) + "px");
        document.documentElement.style.setProperty('--header-height', (document.querySelector('header').offsetHeight) + "px");
    }

    document.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                _calculateVariables();
                ticking = false;
            });

            ticking = true;
        }
    }, { passive: true });

    // recalculate on resize
    window.addEventListener('resize', _calculateVariables, false);
    // recalculate on dom load
    document.addEventListener('DOMContentLoaded', _calculateVariables, false);
    // recalculate on load (assets loaded as well)
    window.addEventListener('load', _calculateVariables);
}());
